import api from '@/libs/axios'
import { PaginatedList } from '../models/common/paginatedList'
import { FamilleDeRisqueEntreprise } from '../models/options/entreprises/actionMilieuTravail/famillesDeRisqueEntreprise';

const resource = 'FamillesDeRisqueEntreprise'

export default class FamillesDeRisqueEntrepriseRessource {
  public async paginatedList(pagenumber?: number, pagesize?: number, search?: string) : Promise<PaginatedList<FamilleDeRisqueEntreprise>> {
    const params = new URLSearchParams();
    if (pagenumber) params.append('PageNumber', pagenumber.toString()); 
    if (pagesize) params.append('PageSize', pagesize.toString()); 
    if (search && search.length) params.append('Search', search?.toString());

    const response = await api.get(`${resource}`, { params: params } )
    return response.data
  }
}
